/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UmbrellaFreelancerPendingRequestResource
 */
export interface UmbrellaFreelancerPendingRequestResource {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaFreelancerPendingRequestResource
     */
    requestToken: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaFreelancerPendingRequestResource
     */
    freelancerFullName: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaFreelancerPendingRequestResource
     */
    companyId: string;
}

/**
 * Check if a given object implements the UmbrellaFreelancerPendingRequestResource interface.
 */
export function instanceOfUmbrellaFreelancerPendingRequestResource(value: object): value is UmbrellaFreelancerPendingRequestResource {
    if (!('requestToken' in value) || value['requestToken'] === undefined) return false;
    if (!('freelancerFullName' in value) || value['freelancerFullName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function UmbrellaFreelancerPendingRequestResourceFromJSON(json: any): UmbrellaFreelancerPendingRequestResource {
    return UmbrellaFreelancerPendingRequestResourceFromJSONTyped(json, false);
}

export function UmbrellaFreelancerPendingRequestResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaFreelancerPendingRequestResource {
    if (json == null) {
        return json;
    }
    return {
        
        'requestToken': json['requestToken'],
        'freelancerFullName': json['freelancerFullName'],
        'companyId': json['companyId'],
    };
}

export function UmbrellaFreelancerPendingRequestResourceToJSON(value?: UmbrellaFreelancerPendingRequestResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'requestToken': value['requestToken'],
        'freelancerFullName': value['freelancerFullName'],
        'companyId': value['companyId'],
    };
}

